import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './components/Dashboard';
import Connected from './components/Connected';
import Webhooks from './components/Webhooks';
import Documents from './components/Documents';
import TestPage from './components/TestPage';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path="connected" element={<Connected />} />
        <Route path="webhooks" element={<Webhooks />} />
        <Route path="documents" element={<Documents />} />
        <Route path="test" element={<TestPage />} />
      </Route>
    </Routes>
  );
}

export default App;
